import {
  type BlazeSchema,
  type DatasetRow,
  getIdColumnName,
  isWorkflowSchema,
} from '@blaze-shared/schema-domain';

import { type DatasetRowWithIndex } from '../../elements/form-list/form-list-rows.service';

export function getFormListIdColumn(schema: BlazeSchema | undefined): string | undefined {
  const columnsInfo = isWorkflowSchema(schema) ? schema : schema?.columns[0]?.dataTypeDef;
  const idColumn = schema && getIdColumnName(columnsInfo);
  return idColumn;
}

export function getFormListDataRowById(
  dataRows: DatasetRow[] | undefined,
  emptyishRows: DatasetRowWithIndex[] | undefined,
  idColumn: string,
  rowId: string | undefined,
):
  | ({ dataRow: DatasetRow } & ({ isEmptyish: false } | { isEmptyish: true; dataRowIdx: number }))
  | undefined {
  if ((!dataRows?.length && !emptyishRows?.length) || !rowId) {
    return undefined;
  }
  let idx = dataRows?.findIndex((r: DatasetRow) => r[idColumn] === rowId) ?? -1;
  if (dataRows && idx !== -1) {
    return { dataRow: dataRows[idx], isEmptyish: false };
  }

  idx = emptyishRows?.findIndex((er) => er.row[idColumn] === rowId) ?? -1;
  if (emptyishRows && idx !== -1) {
    const data = emptyishRows[idx];
    return { dataRow: data.row, isEmptyish: true, dataRowIdx: data.dataIdx };
  }
  return undefined;
}
